import React from 'react';
import { PasswordInput } from './PasswordInput';

export const RegisterForm = ({
    formValues,
    onChange,
    onSubmit,
    onPasswordGenerate,
    acceptedTerms,
    onTermsChange,
    error,
    loading
}) => {
    const { company, firstName, lastName, email, password, confirmPassword } = formValues;

    return (
        <form onSubmit={onSubmit} className="w-100 mt-4 pt-2">
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}
            <div className="mb-4">
                <input
                    type="text"
                    name="company"
                    className="form-control"
                    placeholder="Compañía"
                    value={company}
                    onChange={onChange}
                    required
                />
            </div>
            <div className="mb-4">
                <input
                    type="text"
                    name="firstName"
                    className="form-control"
                    placeholder="Nombre"
                    value={firstName}
                    onChange={onChange}
                    required
                />
            </div>
            <div className="mb-4">
                <input
                    type="text"
                    name="lastName"
                    className="form-control"
                    placeholder="Apellido"
                    value={lastName}
                    onChange={onChange}
                    required
                />
            </div>
            <div className="mb-4">
                <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Correo electrónico"
                    value={email}
                    onChange={onChange}
                    required
                />
            </div>
            <div className="mb-4">
                <PasswordInput
                    name="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={onChange}
                    showGenerator={true}
                    onPasswordGenerate={onPasswordGenerate}
                />
            </div>
            <div className="mb-4">
                <PasswordInput
                    name="confirmPassword"
                    placeholder="Confirmar contraseña"
                    value={confirmPassword}
                    onChange={onChange}
                    showGenerator={false}
                />
            </div>
            <div className="mt-4">
                <div className="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="termsCondition"
                        checked={acceptedTerms}
                        onChange={onTermsChange}
                        required
                    />
                    <label
                        className="custom-control-label c-pointer text-muted"
                        htmlFor="termsCondition"
                        style={{ fontWeight: 400 }}
                    >
                        Acepto todos los <a href="#terms">Términos y Condiciones</a>.
                    </label>
                </div>
            </div>
            <div className="mt-5">
                <button type="submit" className="btn btn-lg btn-primary w-100" disabled={loading}>
                    Crear cuenta
                </button>
            </div>
        </form>
    );
};
